// extracted by mini-css-extract-plugin
export default {"innerWrapper":"cu-z","tooltipWrapper":"du-z","icon":"eu-z","tooltip":"fu-z","content":"gu-z"};